import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';
import { fetchSeries } from 'redux/actions';

const SeriesFetcher = (
    {
        children
    }
) => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.courseList.series.fetched);
    const error = useSelector(state => state.courseList.series.error);

    useEffect(() => {
        dispatch(fetchSeries());
    }, [dispatch])

    if (error) {
        return (
            <Message heading="Error loading series" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader />;
    }

    return children;
};

export default SeriesFetcher;
